import { procedimientosFormulariosService, procedimientosService } from "../services";





export const getDataForms = async (tokenProceso, codigoFormulario) => {

  if(!tokenProceso || !codigoFormulario) return null;

  let dataProceso    = null;
  let dataForm       = null;
  let idRegistroForm = null;

  let messageAlert = {
    text   : 'No se encontro informacion registrada se creara un nuevo registro',
    variant: 'info'
  };

  const responseDataProceso = await procedimientosService.getByToken(tokenProceso);

  if (responseDataProceso) {
    const persona = responseDataProceso.consultamedica.cita.paciente.persona;

    dataProceso = {
      codigo      : responseDataProceso.procedimiento.codigo,
      descripcion : responseDataProceso.procedimiento.descripcion,
      paciente    : `${persona.identificacion} - ${persona.primerApellido} ${persona.primerNombre}`
    }
  }

  const responseDataForm = await procedimientosFormulariosService.getByProceso(tokenProceso, codigoFormulario);

  if(responseDataForm && responseDataForm.length){
    const data = responseDataForm[0];

    idRegistroForm = data.id;
    dataForm = JSON.parse(data.dataJson);
    delete dataForm.id;

    messageAlert = {
      text   : 'Se cargo la informacion registrada',
      variant: 'success'
    }
  }

  const dataReturn = {
    dataForm,
    dataProceso,
    idRegistroForm,
    messageAlert
  }

  return dataReturn;
}